import script from "./YouStoryLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./YouStoryLogo.vue?vue&type=script&setup=true&lang=js"

import "./YouStoryLogo.vue?vue&type=style&index=0&id=0732a033&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0732a033"]])

export default __exports__